import { render, staticRenderFns } from "./saveOrUpdateSencondMarket.vue?vue&type=template&id=7552971a&scoped=true"
import script from "./saveOrUpdateSencondMarket.vue?vue&type=script&lang=js"
export * from "./saveOrUpdateSencondMarket.vue?vue&type=script&lang=js"
import style0 from "./saveOrUpdateSencondMarket.vue?vue&type=style&index=0&id=7552971a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7552971a",
  null
  
)

export default component.exports